import { useMemo } from 'react';
import { PriceStatus } from '@utriper/core';
import { useTranslation } from 'react-i18next';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { SelectCheckbox, TextInput } from '@utriper/core-ui';
import { Box, Button, Grid2, InputAdornment, Typography } from '@mui/material';
import { Add, Search } from '@mui/icons-material';

const PriceGroupTabFilters = () => {
    const { t: translate, i18n } = useTranslation();
    const statusOptions = useMemo(
        () =>
            PriceStatus.getIds().map((status) => ({
                id: status,
                name: PriceStatus.getTranslatedName(PriceStatus.status, status, i18n.language),
            })),
        [i18n.language]
    );
    const { onChangeSearch, onChangeStatus, pgTabNameFilter, pgTabStatusFilter, handleOpenForm } = usePriceGroupTab();

    return (
        <Box component="section" mt="16px">
            <Grid2 container size={12} spacing={2} justifyContent="space-between" flexDirection={{ xs: 'column', md: 'row' }}>
                <Grid2 container size={{ xs: 12, md: 8 }} flexWrap="noWrap" flexDirection={{ xs: 'column', sm: 'row' }}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
                        <TextInput
                            input={{
                                slotProps: {
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            height: '48px',
                                        },
                                    },
                                },
                            }}
                            meta={{ error: null, touched: null }}
                            onChange={onChangeSearch}
                            value={pgTabNameFilter}
                            label={''}
                            placeholder={translate('price_group_tab.filters.name')}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
                        <SelectCheckbox sx={{ width: '100%', height: '48px' }} options={statusOptions} label={translate('price_group_tab.filters.status')} onChange={onChangeStatus} values={pgTabStatusFilter} />
                    </Grid2>
                </Grid2>

                {/* Add New Price Group Tab */}
                <Grid2 container size={{ xs: 12, md: 4 }} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
                    <Button
                        sx={{
                            backgroundColor: 'var(--color-utriper-blue)',
                            padding: '14px',
                        }}
                        variant="contained"
                        startIcon={<Add sx={{ color: '#fff', fontSize: '24px' }} />}
                        onClick={handleOpenForm}
                    >
                        <Typography fontWeight={700} textTransform="none">
                            {translate('price_group_tab.filters.add')}
                        </Typography>
                    </Button>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default PriceGroupTabFilters;
